var FileService =  require("../services/file.service.js").default;

module.exports = function (value) {
  return FileService.fileType(value);
};
